import { useMemo } from 'react';
import { formatDateISO } from '@/utils/date';

/**
 * Hook for computing the default date for value/return forms.
 * Uses userMaxValueDate if available, otherwise today's date.
 */
export function useDefaultDate(userMaxValueDate?: string): string {
    return useMemo(() => {
        return userMaxValueDate || formatDateISO();
    }, [userMaxValueDate]);
}
